import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50"
    >
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <div className="flex items-center gap-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          <span className="text-gray-700">{message}</span>
        </div>
      </div>
    </motion.div>
  );
};

LoadingScreen.propTypes = {
  message: PropTypes.string.isRequired,
};

export default LoadingScreen;
